export const mapToSelectNamesOptions = (items) => {
  return items.map((item) => ({ key: item.id, value: item.name }))
}
